import { Config } from "Config";

export const LD_CONTEXT_GLOBAL = {
  ldContext: { key: Config.anonymousKey, anonymous: true, kind: "user" },
};
